import React from 'react';
import propTypes from 'prop-types';
import { Col, Container, Row } from 'react-bootstrap';
import { SContainer, STitle, SDescription, SRow, SSection } from './style';
import Card from './Card';
import PropTypes from 'prop-types';
import Circles from 'images/svg/double-blue-circle.svg';

export const TeamGrid = ({ data, title, description }) => (
  <SSection>
    <Circles style={{ marginTop: -800, left: -200, position: 'absolute' }} />
    <SContainer>
      <SRow className="header">
        <Col xl="7">
          {title && <STitle>{title}</STitle>}
          {description && <SDescription>{description}</SDescription>}
        </Col>
      </SRow>
      <SRow className="body">
        {data.map((person, key) => (
          <Col
            key={key}
            className="justify-content-center"
            xs="12"
            lg="6"
            xl="4"
          >
            <Card
              image={person.image}
              name={person.name}
              jobTitle={person.job_title}
              description={person.description}
              twitter={person.twitter}
              facebook={person.facebook}
              instagram={person.instagram}
              linkedin={person.linkedin}
              useGracefulImage={true}
            />
          </Col>
        ))}
      </SRow>
    </SContainer>
  </SSection>
);

TeamGrid.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default TeamGrid;
